var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.cruci !== undefined)?_c('div',[_c('Grilla',{key:_vm.count,attrs:{"crucigrama":_vm.cruci},on:{"repaint":_vm.repaint}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }